import { useMemo } from "react";

let i=0;

const useGroupedDataWithTotals = (arrGroupedData) => {
  ////console.log(i+++'--------------arrGroupedData----', arrGroupedData)
  const result = useMemo(() => {
    const groupedDataWithTotals = arrGroupedData.reduce((acc, curr) => {
      //console.log('curr---', curr)
      const {
        Location,
        "Higher Secondary": HigherSecondary = 0,
        "Foundational and Preparatory" : FoundationalandPreparatory = 0,
        "Middle" : Middle=0,
        Secondary = 0,
        Primary = 0,
        "Upper Primary": UpperPrimary = 0,
        "Middle (1-8)": Middle_1_8 = 0,
        "Secondary (1-12)": Secondary_1_12 = 0,
        "Middle (6-8)": Middle_6_8 = 0,
        "Secondary (6-12)": Secondary_6_12 = 0,
        "Secondary (1-10)": Secondary_1_10 = 0,
        "Secondary (6-10)": Secondary_6_10 = 0,
        "Secondary (9-10)": Secondary_9_10 = 0,
        "Secondary (9-12)": Secondary_9_12 = 0,
        "Secondary (11-12)": Secondary_11_12 = 0,
        "Number of Secondary Schools": Number_of_Secondary_School = 0,
        "Number of Secondary Schools having Vocational cource under NSQF at secondary level": Number_of_Secondary_Schools_having_Vocational_cource = 0,
        "Headmaster": Headmaster = 0,
        "Acting Head Teacher": ActingHeadTeacher = 0,
        "Principal": Principal = 0,
        "Foundational and Preparatory and Middle": FoundationalandPreparatoryandMiddle = 0,
        "Middle and Secondary": MiddleandSecondary = 0,
        "Foundational": Foundational = 0,

        "Classes (1-5)": Classes_1_5 = 0,
        "Classes (6-8)": Classes_6_8 = 0,
        "Classes (1-8)": Classes_1_8 = 0,
        "Classes (9-10)": Classes_9_10 = 0,
        "Classes (11-12)": Classes_11_12 = 0,
        "Classes (6-10)": Classes_6_10 = 0,
        "Classes (9-12)": Classes_9_12 = 0,
        "Balvatika (1-3)": Balvatika_1_3 = 0,
        "Balvatika 1- Class 5":Balvatika_1_Class_5 = 0,
        "Balvatika (1-3)": Balvatika_1_3_ = 0,


        Overall = 0,
        "categoriesHigher Secondary only/Jr College":
          categoriesHigherSecondaryonlyJrCollege = 0,
        "categoriesPr Up Pr and Secondary Only":
          categoriesPrUpPrandSecondaryOnly = 0,
        "categoriesPr with UpPr Sec and HSec":
          categoriesPrwithUpPrSecandHSec = 0,
        categoriesPrimary = 0,
        "categoriesPrimary with Upper Primary":
          categoriesPrimarywithUpperPrimary = 0,
        "categoriesSecondary Only": categoriesSecondaryOnly = 0,
        "categoriesSecondary with Higher Secondary":
          categoriesSecondarywithHigherSecondary = 0,
        "categoriesUp Pr Secondary and Higher Sec":
          categoriesUpPrSecondaryandHigherSec = 0,

        "categoriesUpper Pr and Secondary": categoriesUpperPrandSecondary = 0,
        "categoriesUpper Primary only": categoriesUpperPrimaryonly = 0,
      } = curr;


   

      if (!acc[Location]) {
        acc[Location] = {
          records: [],
          totals: {
            Location: ` ${Location}`,
            "School Management(Broad)": "Overall",
            "School Management(Detailed)": "Overall",
            "School Type": "Overall",
            "Urban/Rural":"",

            Primary: 0,
            "Upper Primary": 0,
            "Higher Secondary": 0,
            "Foundational and Preparatory":0, 
            "Middle":0,
            "Middle (1-8)":0,
            "Middle (6-8)":0,
            "Secondary (1-12)": 0,
            "Secondary (6-12)": 0,
            "Secondary (1-10)": 0,
            "Secondary (6-10)": 0,
            "Secondary (9-10)": 0,
            "Secondary (9-12)": 0,
            "Secondary (11-12)": 0,
            "Number of Secondary Schools": 0,
            "Number of Secondary Schools having Vocational cource under NSQF at secondary level":0,
            "Headmaster": 0,
            "Acting Head Teacher": 0,
            "Principal": 0,
            "Foundational and Preparatory and Middle": 0,
            "Middle and Secondary": 0,
            "Foundational": 0,

            

            "Classes (1-5)":0,
            "Classes (6-8)": 0,
            "Classes (1-8)": 0,
            "Classes (9-10)": 0,
            "Classes (11-12)": 0,
            "Classes (6-10)": 0,
            "Classes (9-12)": 0,
            "Balvatika (1-3)":  0,
            "Balvatika 1- Class 5":0,
            "Balvatika (1-3)":  0,


            Secondary: 0,

            Overall: 0,

            "categoriesHigher Secondary only/Jr College": 0,
            "categoriesPr Up Pr and Secondary Only": 0,
            "categoriesPr with UpPr Sec and HSec": 0,
            categoriesPrimary: 0,
            "categoriesPrimary with Upper Primary": 0,
            "categoriesSecondary Only": 0,
            "categoriesSecondary with Higher Secondary": 0,
            "categoriesUp Pr Secondary and Higher Sec": 0,
            "categoriesUpper Pr and Secondary": 0,
            "categoriesUpper Primary only": 0,
            isTotalRow: true,
          },
        };
      }

      // ////console.log('acc', acc)
      //console.log("curr----------->"+JSON.stringify(curr));
      acc[Location].records.push(curr);
// ////console.log(acc[Location].totals.Primary +"-------------"+Primary);
      acc[Location].totals.Primary += Primary;
      acc[Location].totals["Upper Primary"] += UpperPrimary;
      acc[Location].totals["Higher Secondary"] += HigherSecondary;
      acc[Location].totals.Secondary += Secondary;
      acc[Location].totals["Foundational and Preparatory"] += FoundationalandPreparatory;
      acc[Location].totals["Middle (1-8)"] += parseFloat(Middle_1_8);
      acc[Location].totals["Middle (6-8)"] += parseFloat(Middle_6_8);
      acc[Location].totals["Secondary (1-12)"] += parseFloat(Secondary_1_12);
      acc[Location].totals["Secondary (6-12)"] += parseFloat(Secondary_6_12);
      acc[Location].totals["Secondary (1-10)"] += parseFloat(Secondary_1_10);
      acc[Location].totals["Secondary (6-10)"] += parseFloat(Secondary_6_10);
      acc[Location].totals["Secondary (9-10)"] += parseFloat(Secondary_9_10);
      acc[Location].totals["Secondary (9-12)"] += parseFloat(Secondary_9_12);
      acc[Location].totals["Secondary (11-12)"] += parseFloat(Secondary_11_12);
      acc[Location].totals["Number of Secondary Schools"] += Number_of_Secondary_School;
      acc[Location].totals["Number of Secondary Schools having Vocational cource under NSQF at secondary level"] += Number_of_Secondary_Schools_having_Vocational_cource;
      acc[Location].totals.Middle += Middle;
      acc[Location].totals.Headmaster += Headmaster;
      acc[Location].totals["Acting Head Teacher"] += ActingHeadTeacher;
      acc[Location].totals["Foundational and Preparatory and Middle"] += FoundationalandPreparatoryandMiddle;
      acc[Location].totals["Foundational"] += Foundational;
      acc[Location].totals["Middle and Secondary"] += MiddleandSecondary;
      acc[Location].totals.Principal += Principal;
      acc[Location].totals.Overall += Overall;
      acc[Location].totals["categoriesHigher Secondary only/Jr College"] +=
        categoriesHigherSecondaryonlyJrCollege;
      acc[Location].totals["categoriesPr Up Pr and Secondary Only"] +=
        categoriesPrUpPrandSecondaryOnly;
      acc[Location].totals["categoriesPr with UpPr Sec and HSec"] +=
        categoriesPrwithUpPrSecandHSec;
      acc[Location].totals.categoriesPrimary += categoriesPrimary;
      acc[Location].totals["categoriesPrimary with Upper Primary"] +=
        categoriesPrimarywithUpperPrimary;
      acc[Location].totals["categoriesSecondary Only"] +=
        categoriesSecondaryOnly;
      acc[Location].totals["categoriesSecondary with Higher Secondary"] +=
        categoriesSecondarywithHigherSecondary;
      acc[Location].totals["categoriesUp Pr Secondary and Higher Sec"] +=
        categoriesUpPrSecondaryandHigherSec;
      acc[Location].totals["categoriesUpper Pr and Secondary"] +=
        categoriesUpperPrandSecondary;
      acc[Location].totals["categoriesUpper Primary only"] +=
        categoriesUpperPrimaryonly;

      acc[Location].totals["Classes (1-5)"] += Classes_1_5;
      acc[Location].totals["Classes (6-8)"] += Classes_6_8;
      acc[Location].totals["Classes (1-8)"] += Classes_1_8;
      acc[Location].totals["Classes (9-10)"] += Classes_9_10;
      acc[Location].totals["Classes (11-12)"] += Classes_11_12;
      acc[Location].totals["Classes (6-10)"] += Classes_6_10;
      acc[Location].totals["Classes (9-12)"] += Classes_9_12;
      acc[Location].totals["Balvatika (1-3)"] += Balvatika_1_3;
      acc[Location].totals["Balvatika 1- Class 5"] += Balvatika_1_Class_5;

        
      return acc;
    }, {});

    ////console.log("groupedDataWithTotals---->"+JSON.stringify(groupedDataWithTotals));

    const finalResult = Object.values(groupedDataWithTotals).reduce(
      (finalArr, { records, totals }) => {
        //console.log("finalArr",finalArr)
        //console.log("finalArr",records)
        //console.log("finalArr",totals)

        return [...finalArr, ...records, totals];
      },
      []
    );
//console.log("finalResult----",finalResult)
    return finalResult;
  }, [arrGroupedData]);

  //console.log('--------------arrGroupedData----', JSON.stringify(result))
  return result;
};

export default useGroupedDataWithTotals;
